module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/scottrade.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/scottrade.png
// module id = 1181
// module chunks = 0